export default "/images/2fa64f7c3e9dfb64b69e2937c28cac46.avif";